<template>
    <v-dialog v-model="isActive" width="360px" scrollable :overlay="false" max-width="500px"
        transition="dialog-transition">
        <v-card flat>

            <v-card-text v-if="picture !== ''" class="mt-10 d-flex flex-column justify-center align-center">
                <v-card outlined elevation="0" class="rounded-0" style="border: 1px solid #00A0DF ;">
                    <!--                     :src="`data:image/png;base64,${fototmpcarnet}`" -->
                    <v-img :src="`data:image/png;base64,${picture}`" contain></v-img>
                </v-card>
            </v-card-text>

            <v-card-text class="d-flex flex-column justify-center align-center">
                <v-alert dense color="orange darken-2" elevation="0" icon="mdi-alert-circle" dark
                    class="rounded-0 mt-5">
                    Tomar la foto de frente en un fondo claro, sin sombras ni reflejos sobre el rostro o el fondo.
                </v-alert>
                <!-- Mostrar el video si no se ha capturado la foto -->
                <video v-if="!capturado" ref="video" class="d-flex flex-row justify-center"></video>
                <!-- Mostrar la imagen capturada solo si se ha capturado la foto -->
                <canvas v-if="!capturado" ref="canvas" class="d-flex flex-row justify-center"></canvas>
            </v-card-text>
            <v-card-text v-if="!capturado" class="d-flex flex-column align-center justify-center">
                <v-btn @click="capture" elevation="0" class="py-5 mb-1" color="primary" width="300px">
                    <v-icon class="mr-2">mdi-camera-outline</v-icon>
                    CAPTURAR FOTO
                </v-btn>
                <!--                 <v-btn @click="descartarFoto" elevation="0" class="py-5" color="primary" width="300px">
                    <v-icon class="mr-2">mdi-folder-outline</v-icon>
                    SELECCIONAR DE MIS FOTOS
                </v-btn> -->
                <InputPhoto titulo="seleccionar" icono="mdi-folder-outline" width="300px"
                    @fotoCargada="fotoSeleccionada" :tipo="fotocarnet">
                </InputPhoto>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import InputPhoto from '@/components/inputs/InputPhoto.vue'
export default {
    components: {
        InputPhoto
    },
    mounted() {
        this.$nextTick(() => {
            this.iniciarVideo();
        });
    },
    data() {
        return {
            isActive: false,
            callback: null,
            capturado: false,
            overlay: false,
        };
    },
    methods: {
        abrirDialogo() {
            this.isActive = true;
            this.capturado = false; // Reset capturado al abrir el diálogo
            this.iniciarVideo(); // Iniciar el video al abrir el diálogo
            return new Promise((resolve) => {
                this.callback = resolve;
            });
        },
        confirmAndClose(result) {
            if (this.callback) {
                this.callback(result);
                this.callback = null;
            }
            this.isActive = false;
        },
        iniciarVideo() {
            let video = this.$refs.video;
            let constraints = {
                video: {
                    width: { ideal: 278 }, // Ajustar ancho para orientación vertical
                    height: { ideal: 278 }, // Ajustar altura para orientación vertical
                    facingMode: 'user', // 'environment' para cámara trasera, 'user' para cámara frontal
                },
            };
            navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
                video.srcObject = stream;
                video.play();
            });
        },
        async capture() {
            let video = this.$refs.video;
            let canvas = this.$refs.canvas;
            let ctx = canvas.getContext('2d');
            let anchoVideo = video.videoWidth;
            let altoVideo = video.videoHeight;

            canvas.width = anchoVideo;
            canvas.height = altoVideo;
            ctx.drawImage(video, 0, 0, anchoVideo, altoVideo);

            this.capturado = true; // Cambiar el estado a capturado
        },
        descartarFoto() {
            this.capturado = false; // Restablecer el estado para mostrar el video nuevamente
            this.iniciarVideo(); // Reanudar la transmisión de video
        },
    },
    props: {
        picture: {
            type: String,
            required: true,
            default: ''
        }
    }
};
</script>